module.exports = __webpack_public_path__ + "static/media/mode-20.4cb182ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-20.svg
// module id = 993
// module chunks = 2